import styled from 'styled-components';
import { theme } from '../theme';
import { BodyText } from '../typography';

interface StyledSwitchProps {
  disabled?: boolean;
  checked?: boolean;
}

export const StyledSwitchLabel = styled.label<StyledSwitchProps>`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  color: ${(props) =>
    props.disabled ? theme.colors.primaryK3 : theme.colors.primaryK10};
`;

export const HiddenCheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  height: 0;
  width: 0;
`;

export const SwitchLabel = styled(BodyText)`
  margin: 0;
  margin-right: 0.625rem;
`;

export const StyledSlider = styled.span<StyledSwitchProps>`
  width: 3.75rem;
  height: 1.875rem;
  cursor: pointer;
  transition: 0.4s;
  border: 0.125rem solid;
  border-radius: 2.125rem;
  position: relative;
  box-sizing: border-box;
  ${(props) => {
    if (props.disabled) {
      return `
        background-color: ${props.theme.colors.primaryK1};
        border-color: ${props.theme.colors.primaryK3};
      `;
    }
    if (props.checked) {
      return `
        background-color: ${props.theme.colors.primaryW};
        border-color: ${props.theme.colors.primaryT2};
        &:hover {
          border-color: ${props.theme.colors.primaryT1};
        }
      `;
    }
    return `
      background-color: ${props.theme.colors.primaryW};
      border-color: ${props.theme.colors.primaryK10};
      &:hover {
        border-color: ${props.theme.colors.primaryK7};
      }
    `;
  }}
`;
export const StyledCircle = styled.span<StyledSwitchProps>`
  position: absolute;
  height: 1.375rem;
  width: 1.375rem;
  left: 0.125rem;
  bottom: 0.125rem;
  transition: 0.4s;
  border-radius: 50%;
  ${(props) => {
    if (props.disabled) {
      return `
        background-color: ${props.theme.colors.primaryK3};
      `;
    }
    if (props.checked) {
      return `
        transform: translateX(1.875rem);
        background-color: ${props.theme.colors.primaryT2};
    `;
    }
    return `
      background-color: ${props.theme.colors.primaryK7};
    `;
  }}
`;
